const NEW_CARD_PAYMENT_METHOD_PREFIX = "pm_nc";
const NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX = "pm_nfc";

export const NEW_CARD_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_disable_msg`,
    WE_ACCEPT_CARD_LIST: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_wacl`,
    NON_TOKENIZE_CARD_REMOVAL_MSG: `${NEW_CARD_PAYMENT_METHOD_PREFIX}_card_removal_msg`,
};

export const NEW_FOOD_CARD_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_disable_msg`,
    WE_ACCEPT_CARD_LIST: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_wacl`,
    NON_TOKENIZE_CARD_REMOVAL_MSG: `${NEW_FOOD_CARD_PAYMENT_METHOD_PREFIX}_card_removal_msg`,
};
